// USA
export const locale = {
  lang: 'en',
  data: {
    search: 'Search',
    add: 'Add New',
    edit: 'Edit',
    view: 'View',
    dashboard: 'Dashboard',
    TRANSLATOR: {
      SELECT: 'Select your language',
    },
    ROUTE: {
      search: 'Search',
      dashboard: 'Dashboard',
      add: 'Add',
      edit: 'Edit',
      view: 'View',
      labs: 'Laboratory Results',
      radiologies:'Radiology Results',
      profile:'Profile' ,
      portal:'User System' ,
      appointments : 'My Appointments' ,
      addappointment: 'New Appointment', 
      specialties:'Specialties',
      doctors:'Doctors',
      invoices:'My Incoices',
      approvals:'Insurance Approvals',
      visits:'Visits',
      chat:'Chat',
      settings:'Settings',
      patientvisits:'My Visits',
      switch:'Switch user',
      family:'Family',
      addnewmember: 'Add New Member',
      birthrequests:'Birth requests',
      birthrequestsstaff:'Birth requests',
      sickleaverequests:'SickLeave requests',
      medicalReportrequests:'Medical report',
      payments:'Pending Payments',
      complaintsandsuggestions :'Complaints-Suggestions',
      offerrequests:'Offers Requests',
      offersandpackages:'Offers And Packages',
      news:'News',
      outsideTest:'Outside Tests',
      board:'Board'

    },
    MENU: {
      LOGIN: 'Login',
      AppTitle: 'Balsam Medical Care',
      NEW: 'new',
      ACTIONS: 'Actions',
      CREATE_POST: 'Create New Post',
      PAGES: 'Pages',
      FEATURES: 'Features',
      APPS: 'Apps',
      DASHBOARD: 'Home',
      ALL: 'ALL',
      ACTIVE: 'ACTIVE',
      RAYSANDTESTS: 'Rays and tests',
      HOME:'Home',
      CONTACTUS:'Contact',
      ABOUTUS:'About Us',
      ABOUTUSNew:'Our Story',
      ENTITIES:'Our Network',
      HOPITALS:'Our Hospitals',
      MEDICALCENTERS : 'Our Medical Centers',
      Board : 'Board Of Directors',
      BoardOfDirectors : 'Excutive Management',
      DOCTORS:'Doctors',
      SPECIALTIES:'Specialties',
      ADMINPANEL:'User Services',
      BLOG:'News',
      LABS:'Laboratory Results',
      RADIOLOGY:'Radiology Results',
      PROFILE:' Profile ',
      SOCIALMEDIA:'Media Center',
      APPOINTMENTS:'My Appointments',
      INVOICES:'My Invoices',
      APPROVALS:'Insurance Approvals',
      VISITS:'Visits',
      CONGRATS:'Congrat cards',
      SETTINGS:'Settings',
      PATIENTVISITS:'My Visits',
      FAMILY:'Family',
      SwitchFamily:'Switch Family',
      DOCTORSLOTS:'Doctor slots',
      BIRTHREQUESTS:'Birth requests',
      SICKLEAVEREQUEST:'SickLeave requests',
      MEDICALREPORTREQUEST:'Medical report',
      PAYMENTS : 'Pending Payments',
      complaintsandsuggestions :'Complaint-Suggestion',
      COMPLAINTSANDSUGGESTIONS :'Complaints / Suggestions',
      offerrequest:'Offers Requests',
      OUTSIDETEST:'Outside Tests',
      SURVEY:'Survey',
       BlogDetails : 'News Details',
       OFFERS:"Be a Success Partner",
       CAREERS:"Career",
       BOOKOFFER:"Register Your Info",
       BOARD:'Board'
    },
    AUTH: {
      GENERAL: {
        OR: 'Or',
        SUBMIT_BUTTON: 'Submit',
        NO_ACCOUNT: 'Don\'t have an account?',
        HAVE_ACCOUNT: 'Have an account?',
        SIGNUP_BUTTON: 'Sign Up',
        FORGOT_BUTTON: 'Forgot Password',
        BACK_BUTTON: 'Back',
        PRIVACY: 'Privacy',
        LEGAL: 'Legal',
        CONTACT: 'Contact',
        SIGNOUT: 'Sign Out',
        FORGOTPASSWORD:'Reset password',
        REMEMBERME:'Remember me',
        CHANGEPASSWORD:'Change password',
        DELETEACCOUNT :'Delete my account',
        DELETEACCOUNTPARA:'Are you sure to delete your account?',
        STAFF:'Staff'
      },
      LOGIN: {
        TITLE: 'Login Account',
        STAFFTITLE: 'Login Account',
        BUTTON: 'Sign in',
      },
      FORGOT: {
        TITLE: 'Forgotten Password?',
        DESC: 'Enter your email to reset your password',
        SUCCESS: 'Your account has been successfully reset.'
      },
      REGISTER: {
        TITLE: 'Sign Up',
        DESC: 'Enter your details to create your account',
        SUCCESS: 'Your account has been successfuly registered.',
        TERMS:'Terms & Conditions',
        AGREE:'Yes, I agree with all '
      },
      INPUT: {
        EMAIL: 'Email',
        FIRSTNAME: 'First Name',
        PASSPORTNO:'National ID / Iqama',
        PERSONALNO:'Username',
        LASTNAME: 'Last Name',
        PASSWORD: 'Password',
        PHONENUMBER:'Phone Number (5xxxx)',
        AGE:'Age',
        GENDER:'Gender',
        CONFIRM_PASSWORD: 'Confirm Password',
        USERNAME: 'Username',
        NEWPASSWORD:'New Password',
        OLDPASSWORD:'Current Password',
        ENTERCODE:'Enter your code',
        ENTERCODEPARA:'We sent a 6-digit code to your phone number'
      },
      VALIDATION: {
        INVALID: '{{name}} is not valid',
        REQUIRED: '{{name}} is required',
        MIN_LENGTH: 'Minimum length is {{min}} characters',
        MAX_LENGTH: 'Maximum length is {{max}} characters',
        AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
        NOT_FOUND: 'The requested {{name}} is not found',
        INVALID_LOGIN: 'The login detail is incorrect',
        REQUIRED_FIELD: 'Required field',
        MIN_LENGTH_FIELD: 'Minimum field length:',
        MAX_LENGTH_FIELD: 'Maximum field length:',
        INVALID_FIELD: 'Field is not valid',
        PLEASEENTER: 'Please enter',
        ENTERDCORRECT: 'was entered correct',
        NAMEARABIC: '{{name}} Must be Arabic letters',
        NAMEENGLISH: '{{name}} Must be English letters',
        COMPAREDATES: '{{MaxDate}} should be greater than {{MinDate}}',
        LessThanToday:'{{Date}} should be less than today',
        GreaterThanOrEqualToday:'{{Date}} should be greater than or equal today',
        COMPARENUMBERS: '{{Num2}} should be greater than {{Num1}}',
        VALIDATEMOBILE: 'Invalid phone number',
        VALIDATEEMAIL: 'Incorrect email',
        VALIDATIONIDENTITYNUMBER:'You must enter valid ID number ',
        DIDNOTMATCH_FIELD:'Passsword and Confirm Password did not match.',
        PASSWORDCONS:'The password must contain 6 or more english characters, including an uppercase letter',
        MOBILE_VALIDATION : 'You must enter a valid mobile number',
        NAME_VALIDATION: 'You must enter a valid words',
        ID_VALIDATION:'You must enter a valid ID No.'
      }
    },
    COMMON: {
      SUBMMIT:'Submit',
      ContactUs:'Contact',
      ACTIONS: 'Actions',
      SELECTED_RECORDS_COUNT: 'Selected records count: ',
      ALL: 'All',
      SUSPENDED: 'Suspended',
      ACTIVE: 'Active',
      SEARCH: 'Search',
      CLEAR: 'clear',
      SEARCHRESULTS: 'search results',
      BASICINFO: 'Basic info',
      BACK: 'Back',
      RESET: 'Reset',
      EDIT: 'Edit',
      DELETE: 'Delete',
      SAVE: 'Save',
      CANCEL: 'Cancel',
      SELECT: 'Select',
      ASSIGN: 'Assign',
      OK: 'Ok',
      YES: 'Yes',
      NO: 'No',
      TO: 'to',
      OF: 'of',
      CLOSE: 'Close',
      SHOWINGROWS: 'Showing rows',
      VIEW: "View Details",
      NEWSLETTER:'Join Our Newsletter',
      NEWSLETTERPARA:'Subscribe with us to receive the latest updates, offers and important medical information',
      SUBSCRIBE:'Subscribe',
      CALL:'Call',
      SEARCHHERE:'Search here...',
      QUICKLINKS:'Quick Links',
      FEEDBACK:'Feedback' ,
      DOWNLOAD:'Download',
      DELETEACCOUNT:'Delete my account',
      VIEWREPORT:'View',
      CONFIRM:'Confirm',
      COMPELETE:'Compelete Request',
      DOWNLOADREPORT:'Download Report',
      PAY: 'Pay',
      ADDNEW:'Add New'
    },
    DASHBOARD: {
      GETAPPOINTMENT: 'Get Appointment',
      LEARNMORE:'Learn More',
    },
    CONTACTUS: {
      CONTACTUS:'Contact',
      PHONE:'Phone',
      POSTALCODE:'P.O Box',
      EMAIL:'Email',
      LOCATION:'Location',
      LOCATIONPARA:'Al Raya st, Al Nadwahm, Riyadh 14813, Suadi Arabia',
      DROPYOURMESSAGE:'Drop your message for any info or question.',
      NAME:'Name',
      SUBJECT:'Subjext' ,
      MESSAGE:'Message',
      SEND:'Send',
      EMERGENCYCALL:'Emergency Call',
      MOBILE1:'+966 92 002 4111',
      MOBILE2:'+966 53 124 8548',
    },
    ABOUTUS: {
      ABOUTUS:'About US',
      ABOUTHOSPITAL:'Balsam Medical Care',
      // ABOUTHOSPITALPARA:'With the development of society, high-quality health care has become a basic requirement for all its members, and the bet of the government of the Custodian of the Two Holy Mosques, may God protect him, has been focused on achieving a set of strategic goals that guarantee improving the quality of life of community members by providing health services with a curative, preventive or rehabilitative dimension that keeps pace with all categories and ages, and ensuring easy access for all members of society to these services, by relying on standards and indicators that achieve the concepts of total quality and the development of health care services.The private sector has become a key role in achieving this far strategy, especially after the launch of Vision 2030, based on its parallel and complementary position to the state’s role in establishing and financing health projects on the one hand, and absorbing human energies at the operational level and benefiting from high-quality health services on the other hand.Hence, the role of the Family Care Hospital came to provide an example for the hospitals that have joined seriously and responsibly in this huge project, to constitute a qualitative addition to the infrastructure of health care facilities in the Riyadh region, and to be a model for hospitals that respond to the quality requirements recognized locally and globally.',
      EMPLOYEES:'Annual Patient Visits',
      DOCTORSANDNURSE:'Employees',
      CLINICKS:'Outpatient Clinics',
      PATIENTSBEDS:'Beds' ,
      OURGOALS:'Our Goals',
      PATIENTCARE:'Patient care',
      PATIENTCAREPARA:'Satisfying patients and their families by providing services that meet international standards of quality.',
      BRANCHES:'Branches',
      BRANCHESPARA:'Expanding our branches across the cities of the Kingdom of Saudi Arabia along the Gulf.',
      DOCTORSCARE:'Doctors care',
      DOCTORSCAREPARA:'Supporting the continuous training of our human cadres, and encouraging them for self-learning.',
      SOCIALMEDIA:'Social media',
      SOCIALMEDIAPARA:'Continuous development of work mechanisms and means of communication with patients and their families.',
      OURBLOGS:'News',
      READMORE:'Read more'
    },
    LABS: {
      COMMON: {
        FILTER: 'Search for Laboratories',
        BY_NAME: 'By Test Name',
      },
      GRID: {
        VISITDATE: 'Visit Date',
        RESULTDATE:'Result Date',
        TECHNAME: 'Doctor Name',
        ORDERNUMBER: 'Order Number',
      },
    },
    RADIOLOGY: {
      COMMON: {
        FILTER: 'Search for Radiology',
        BY_NAME: 'By Name',
      },
      GRID: {
        VISITDATE: 'Visit Date',
        SERVICENAME: 'Radiology Name',
        AUTHDOCNAME: 'Doctor Name',
        RESULTSTATUS: 'Result Status',
      },
    },
    APPOINTMENTS: {
      COMMON: {
        FILTER: 'Search for appointment',
        BY_FROMDATE: 'From Date',
        BY_TODATE: 'To Date',
      },
      GRID: {
        VISITDATE: 'Visit Date',
        APPOINTMENTDATE: 'Appointment Date',
        SPECIALTY:'Specialty',
        DOCTORNAME: 'Doctor',
        VISITTYPE:'Visit Type',
        STATUS: ' Status',
        NEWAPPOINTMENT:'New Appointment',
        CLICK:'Click',
        IsPayed:'Is Payed'
      },
      ADD:{
        NEWAPPOINTMENT:'New Appointment',
        SPECIALTY:'Choose Specialty',
        DOCTOR:'Choose Doctor Name',
        DATE:'Choose Appointment Date',
        CHOOSEYOUDATE:'Choose the right time for you',
        VALIDATEDATE:'You must choose a date equal to today or in the future'

      },
      CONFIRMAPPOINTMENT:{
        TITLE:'Appointment Confirmation',
        MESSAGE:'Are you sure to confirm this appointment?'
      },
      CANCELAPPOINTMENT:{
        TITLE:'Appointment Cancelation',
        MESSAGE:'Are you sure to cancel this appointment?'
      },
      PAYAPPOINTMENT:{
        TITLE:'Payment fees',
      }
    },
    INVOICES: {
      COMMON: {
        FILTER: 'Search for Invoice',
        BY_FROMDATE: 'From Date',
        BY_TODATE: 'To Date',
      },
      GRID: {
        BILLDATE: 'Bill Date',
        SERVICENAME: 'Service Name',
        PAYMENTTYPE: 'Payment Type',
        SPECIALTY:'Specialty Name',
        ACTUALAMOUNT:'Service Price',
        TOTALAMOUNT:'Total Amount',
        AMOUNT:'Amount',
        PAIDAMOUNT:'Patient Share',
        DATE:'Date'
      },
    },
    BIRTHREQUEST: {
      COMMON: {
        FILTER: 'Search for Birth requests',
        BY_FROMDATE: 'From Date',
        BY_TODATE: 'To Date',
        BY_STATUS:'By Status',
        BY_MOTHERFILENO:'By MRN',
        BY_REQUESTNUMBER:'By Request Number',

      },
      GRID: {
        REQUESTDATE: 'Request Date',
        REQUESTNUMBER:'Request Number',
        PATIENTCOMMENT:'Patient Comment',
        HOSPITALCOMMENT:'Hospital Comment',
        BIRTHTYPE:'Birth Type',
        PERSONREPORTEDNAME:'Reporting Name',
        STATUS:'Status',
        FATHERID:'FatherID',
        MOTHERID:'MotherID',
        BABYNAME:'Baby Name',
        MRN:'MRN',
        Pendin:'Pending',
        Completed:'Completed',
        InProgress:'In Progress',
        RequestSe7ty : 'Request for Sehhaty',
        RequestMedicalReport : 'Medical Report Request'

      },
      ADD:{
        NEWBIRTHREQUEST:'New Birth Request',
        VIEWBIRTHREQUEST:'View Birth Request Details',
        VIEWSICKLEAVEREQUEST:'View SickLeave Request Details',
        VIEWsuggestion:'View Suggestion Details',
        VIEWcomplaint:'View Complaint Details',
        VIEWMEDICALREPORTREQUEST:'View Medical Report Request Details',
        BABYINFORMATION:'Baby Information',
        BABYNAME:'Name',
        BABYGENDER:'Gender',
        SINGLE:'Single',
        TWIN:'Twin',
        FATHERINFORMATION:'Father Information',
        FIRSTNAME:'First Name',
        MIDDLENAME:'Second Name',
        LASTNAME:'Third Name',
        FAMILYNAME:'Family Name',
        IDNO:'IDnumber',
        SERIAL:'Serial',
        NATIONALITY:'Nationality',
        IDTYPE:'ID Type',
        RELIGION:'Religion',
        MOBILE:'Mobile NO.',
        MOTHERINFORMATION:'Mother Information',
        RELATIVERELATION:'Relative',
        REPORTINGPERSONINFO:'Reporting Person Information',
        REPORTINGMAME:'Reporting Person Name',
        REPORTEDDATE:'Date',
        REPORTINGIDNO:'IDnumber',
        MOTHERFILENO:'Mother File NO.',
        BABYFILENO:'Father File NO.',
        ATTACHMENT:' Attachments',
        REQUIREDATTACHMENT:'Required Attachments',
        COMMENTS:'Comments',
        InsertionDate:'Date',
        UserName:'User Name',
        Comment:'Comment',
        WriteYourComment:'Write your comment'

      }
    },
    OFFERS: {
      COMMON: {
        BY_FROMDATE: 'From Date',
        BY_TODATE: 'To Date',
      },
      GRID: {
      
      },
      ADD:{
        NewOfferSection:'Add News',
        OfferSectionNameEnglish:'Header (English)',
        OfferSectionNameArabic:'Header (Arabic)',
        IsActive:'Is Active',
        AddNewOffer:'Add News',
        OfferNameEnglish:'Details (English)',
        OfferNameArabic:'Details(Arabic)',
        offerImage:'Image',
      },
    },
    Board: {
      COMMON: {
        BY_FROMDATE: 'From Date',
        BY_TODATE: 'To Date',
        BY_Name: 'By Name',
      },
      ADD:{
        NewMember:'Add New Member',
        NameEn:'Name (English)',
        NameAr:'Name (Arabic)',
        TitleAr : 'Title (Arabic)',
        TitleEn : 'Title (English)',
        BioAr : 'Bio (Arabic)',
        BioEn : 'Bio (English)',
        IsActive:'Is Active',
        Order:'Order',
        Image:'Image',
        BoardTeamType:'Board Team Type',
        Board:'Board',
        BoardOfDirectors:'Board Of Directors'
      },
    },
  }
};
